// ProductFeatures.jsx

import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};

const ProductFeatures = () => {
  return (
    <section className="w-full bg-[#f3f3f3] py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        
        {/* Heading */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold text-[#1f4ba5]">
            Product Features
          </h2>

          <p className="text-gray-600 max-w-4xl mx-auto mt-5 leading-relaxed text-md">
           Society has put up so many boundaries, so many limitations on what’s right and wrong that it’s almost impossible.
          </p>
        </motion.div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          
          {/* Left Side */}
          <motion.div
  variants={fadeUp}
  initial="hidden"
  whileInView="show"
  viewport={{ once: true }}
>
  <h3 className="text-3xl font-bold text-[#1f4ba5] mb-1">
    Product Description
  </h3>
  <p className="text-gray-600 leading-2 mb-1 text-md">
    Air conditioning, abbreviated as AC, is a system designed to regulate and maintain the temperature, humidity, and air quality within a defined space, typically indoors. It works by removing heat from the air inside a room or building and transferring it to the outdoors, thus cooling the indoor environment. AC systems vary in size and complexity, ranging from small units designed for single rooms to large systems that can cool entire buildings or complexes.
  </p>

  <div className="space-y-3">
    <div>
      <h4>
        <span className="font-bold text-[#1f4ba5] text-md">Condenser Coil:</span> <span className="text-gray-600 leading-2 text-md">The condenser coil is located outdoors and is responsible for releasing the heat absorbed from the indoor air.</span>
      </h4>
     
    </div>
 <div>
      <h4>
        <span className="font-bold text-[#1f4ba5] text-md">Evaporator Coil:</span> <span className="text-gray-600 leading-2 text-md"> This component is located indoors and is responsible for absorbing heat from the indoor air as it passes over the coil.</span>
      </h4>
     
    </div>
 <div>
      <h4>
        <span className="font-bold text-[#1f4ba5] text-md">Compressor:</span> <span className="text-gray-600 leading-2 text-md">This component is typically located outdoors and plays a crucial role in the cooling process by compressing and circulating refrigerant between the evaporator and condenser coils.</span>
      </h4>
     
    </div>
  </div>
</motion.div>
          {/* Right Side Images */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <div className="">
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgy1uxhc9TuTNxsuCHN0sR8MjHDiHCMzY_2BT_-tx49Yc_TVZTqFMYzz7zUp7rlozTiuEIkTWyrQuxyWAXrXnHSGuYtIdre41sLaNqBCZmHXYGJ82Hpy8PWfua-Hh0aWqY9DaBsITcvHaSHxEVhd0wwfji8NdmQkMNfsBayjuLTllYR6HCAeP2Z9vpFXZY/w446-h401/Untitled%20design%20(8).png"
                alt="Product Features"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProductFeatures;
